import { HANZI_PROMPT_KINDS } from "../core/model/settings.ts";
import type { SetSummary } from "../core/view/sets.ts";

export type Paused = "all" | "none" | "mixed";

// Whether the meaning and pinyin kinds are paused, over every set that declares them. With none declared it reads
// "all", so the switch defaults to checked.
export function hanziPromptsPaused(sets: readonly SetSummary[]): Paused {
  const flags = sets.flatMap((set) => HANZI_PROMPT_KINDS.flatMap((k) => (k in set.kinds ? [set.kinds[k]] : [])));
  if (flags.every(Boolean)) return "all";
  return flags.some(Boolean) ? "mixed" : "none";
}
